<template lang="pug">
v-navigation-drawer(
    absolute,
    temporary,
    :value="value",
    @input="handleDrawer"
  )
  v-list(dense)
    v-list-item(
      v-if="user.role.slug == 'admin'",
      v-for="(item, i) in nav_admin",
      :key="i",
      :to="item.path",
      link,
      color="secondary"
    )
      v-list-item-icon
        v-icon(v-text="item.icon")
      v-list-item-content
        v-list-item-title.title {{ item.text }}
    v-list-item(
      v-if="user.role.slug == 'vet'",
      v-for="(item, i) in nav_vet",
      :key="i",
      :to="item.path",
      link,
      color="secondary"
    )
      v-list-item-icon
        v-icon(v-text="item.icon")
      v-list-item-content
        v-list-item-title.title {{ item.text }}
    v-list-item(
      v-if="user.role.slug == 'owner'",
      v-for="(item, i) in nav_owner",
      :key="i",
      :to="item.path",
      link,
      color="secondary"
    )
      v-list-item-icon
        v-icon(v-text="item.icon")
      v-list-item-content
        v-list-item-title.title {{ item.text }}
    v-list-item(v-if="user.role.slug != 'owner'", to="/email", link)
      v-list-item-icon
        v-icon fa-envelope
      v-list-item-content
        v-list-item-title.title Correos
  template(v-slot:append)
    v-list(dense)
      v-list-item(@click="signOut", color="secondary")
        v-list-item-icon
          v-icon(color="primary") fa-sign-out-alt
        v-list-item-content
          v-list-item-title.title.primary--text Cerrar Sesión
</template>

<script>
export default {
  name: "UserMenuSide",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      nav_admin: [
        { icon: "fa-paw", text: "Mascotas", path: "/pets" },
        { icon: "fa-cubes", text: "Stock", path: "/stock" },
        { icon: "fa-users", text: "Usuarios", path: "/users" },
        { icon: "fa-dog", text: "Especies", path: "/species" },
        { icon: "fa-boxes", text: "Inventario", path: "/inventories" },
        { icon: "fa-truck-loading", text: "Proveedores", path: "/providers" }
      ],
      nav_vet: [
        { icon: "fa-paw", text: "Mascotas", path: "/pets" },
        { icon: "fa-users", text: "Propietarios", path: "/users" },
        { icon: "fa-boxes", text: "Inventario", path: "/inventories" },
        { icon: "fas fa-syringe", text: "Vacunas", path: "/vaccinations" },
        {
          icon: "fa-calendar-alt",
          text: "Citas Médicas",
          path: "/appointments"
        },
        {
          icon: "fas fa-plus-square",
          text: "Historial Médico",
          path: "/medical_histories"
        }
      ],
      nav_owner: [
        { icon: "fa-paw", text: "Mis Mascotas", path: "/pets" },
        {
          icon: "fa-calendar-alt",
          text: "Mis Citas Médicas",
          path: "/appointments"
        }
      ]
    };
  },
  methods: {
    signOut() {
      window.localStorage.removeItem("user");
      window.localStorage.removeItem("auth_token");
      this.$store.commit("auth/setUser", null);
      this.$store.commit("auth/setTokenAuth", null);
      window.location.href = process.env.VUE_APP_URL;
    },
    handleDrawer(value) {
      this.$emit("input", value);
    }
  }
};
</script>
